import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '.../../environments/environment';
import { AuthService } from '../../../_services/index';
import { LoaderService } from 'app/_services/loader.service';
import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { process, State } from '@progress/kendo-data-query';
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { Observable } from 'rxjs';
//import { InventoryService } from './inventory.service';
declare var $: any;

import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
import { ThemeService } from '@progress/kendo-angular-charts';
const moment = _rollupMoment || _moment;

const distinctCat = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.CATNAME === x.CATNAME) === idx);
const distinctSubCat = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.SUBCATNAME === x.SUBCATNAME) === idx);
const distinctPartType = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.PARTTYPENAME === x.PARTTYPENAME) === idx);
const distinctUOM = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.UOMTYPENAME === x.UOMTYPENAME) === idx);

@Component({
  selector: 'invoiceChallan',
  templateUrl: './invoiceAndChallan.component.html'
})
export class invoiceAndChallanComponent {

  public state: State = {
    skip: 0,
    take: 50,
    filter: {
      logic: 'and',
      filters: []
    }
  };
  showLoader: boolean;
 
  groups: GroupDescriptor[];
  prjId: string;
  userId: string;
  file: File;
  Invoicedata: any;
  selectedInvoiceNumber: any;
  fileSected: boolean;
  readyToUploadChallanFile: boolean;
  readyToUploadInvoiceFile: boolean;
  billType: string;
  FinalInvoiceNumber: string;
  FinalInvoiceNumberCheck: boolean;
  downloadURL: any;
  challanModel: any;
  InvoiceWiseData: any;
  TotalQuantity: any;
  TotalAmount: any;
  invoiceNumber: any;
  partsArray: any;
  partsIdArray: any;
  defaultStartDate: string;
  defaultEndDate: string;
  dateRangeModal: any;
  
 


  private loadProducts(): void {
    this.gridinventory = process(this.Invoicedata, { group: this.groups });
  }
  public gridinventory: GridDataResult;

  constructor(
    private auth: AuthService,
    private http: HttpClient,
    private loaderService: LoaderService,
    public router: Router,
    //public _inventory: InventoryService
  ) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
    this.fileSected = false;
    this.readyToUploadChallanFile = true;
    this.readyToUploadInvoiceFile = true;
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    this.defaultStartDate = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
    this.defaultEndDate = (date.getFullYear()) + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    this.dateRangeModal = { beginDate: { year: firstDay.getFullYear(), month: firstDay.getMonth() + 1, day: firstDay.getDate() }, endDate: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() } };
  }



  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.loadProducts();
  }

  

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridinventory = process(this.Invoicedata, this.state);
    if (state && state.group) {
      this.gridinventory = process(this.Invoicedata, this.state);
    }
  }

  downloadExcelFile(vehicleInfoData) {
    const ws_name = 'PartInfo';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(vehicleInfoData);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
    saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'PartInfo.xlsx');
  }
  s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  }


ngOnInit() {
    this.prjId = this.auth.getAuthentication().projectId;
    this.userId = this.auth.getAuthentication().id;
    let fromDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
    let toDate = moment(this.defaultEndDate).format('YYYY-MM-DD');

     this.getInvoicedata(fromDate,toDate);
    $('#UpdateChallanFile, #UpdateInviceFile').modal({backdrop: 'static', keyboard: false})  

    var config = {
			authDomain: "ecogreen-citizen-app.firebaseapp.com",
			apiKey: 'AIzaSyAHMkYkbjRTa9RazdKPJjtOJrdHCZVxxYg',
			databaseURL: 'HttpClient s://ecogreen-citizen-app-2ad05.firebaseio.com/',
			storageBucket: 'ecogreen-citizen-app.appspot.com',
			projectId: 'ecogreen-citizen-app'
		};
		firebase.initializeApp(config);

    
  }


  AddChallan(invoiceNumber,billType) {

    this.selectedInvoiceNumber = invoiceNumber;
    this.billType = billType

    console.log('113',invoiceNumber);
    
     
    this.readyToUploadChallanFile = true;

    $('#UpdateChallanFile').modal('show');
  }

  openFileUploader(){
    $('#UpdateChallanFile .fileUploader .filedoc').click();
  }

  openInvoiceFileUploader(){
    $('#UpdateInviceFile .fileUploader .filedoc').click();
  }

  addInvoice(invoiceNumber,billType) {
    this.readyToUploadInvoiceFile = true;
     
    this.selectedInvoiceNumber = invoiceNumber;
    this.billType = billType

    console.log('145',this.selectedInvoiceNumber,this.billType);
    
    
    $('#UpdateInviceFile').modal('show');
  }

  ViewInvoiceChallan() {
    $('#InvoiceAndChallanDetails').modal('show');
  }

  // detectFiles($event){

  //   console.log('143 file select ');
    
  //   this.file = $event.target.files[0];
 
  //   console.log('143 file select ', this.file);

  //   this.fileSected = true;

  // }

  clearFieldsAndVars(){
    // this.readyToUploadInvoiceFile = false;
    // this.readyToUploadChallanFile = false;
    this.fileSected = false;
    $(".filedoc").val("");
  }

  


  saveChallanFile(billTypecheck){
    
     if(billTypecheck == 'invoice'){

        if( this.FinalInvoiceNumber  == ''|| this.FinalInvoiceNumber == undefined || this.FinalInvoiceNumber == null){

          this.FinalInvoiceNumberCheck = true;
        }

     }


    let formData = new FormData();
    formData.append("file", this.file);
     


      

  
    
    this.http.post(environment.apiUrl + 'maintenance/uploadChallansAndInvoices?lotNumber='+this.selectedInvoiceNumber+"&billType="+this.billType+"&invoiceNumber="+this.FinalInvoiceNumber, formData).subscribe((data) => {

      console.log('129',data);
      
       
      $(".filedoc").val("");

      $('#UpdateChallanFile').modal('hide');

      this.FinalInvoiceNumberCheck = false;

    }, error => {
       
    });

  }



  getInvoicedata(fromDate,toDate){


    // if (moment().quarter() === 2) {
    //   var thisFiscalStart = moment().month('April').startOf('month').format('YYYY-MM-DD')
    //   var thisFiscalEnd = moment().add(2, 'year').month('March').endOf('month').format('YYYY-MM-DD')
    // } else {
    //   var thisFiscalStart = moment().subtract(1, 'year').month('April').startOf('month').format('YYYY-MM-DD')
    //   var thisFiscalEnd = moment().month('March').endOf('month').format('YYYY-MM-DD')
    // };
    
    // var lastFiscalStart = moment(thisFiscalStart).subtract(1, 'year').format('YYYY-MM-DD')
    // var lastFiscalEnd = moment(thisFiscalEnd).subtract(1, 'year').format('YYYY-MM-DD')
    
    // console.log('256',thisFiscalStart)
    // console.log('256',thisFiscalEnd)


    // console.log('256',lastFiscalStart)
    // console.log('256',lastFiscalEnd)




   
    let fromDatee = moment(fromDate).format('YYYY-MM-DD');
    let toDatee = moment(toDate).format('YYYY-MM-DD');





    this.loaderService.display(true);

     




    this.http.get(environment.apiUrl + 'maintenance/getInvocedata?prjId='+this.prjId+'&thisFiscalStart='+fromDatee+'&thisFiscalEnd='+toDatee).subscribe((data) => {
      this.Invoicedata = data ;

      console.log('this.Invoicedata',this.Invoicedata);

      
      if (this.Invoicedata.length > 0) {
        this.gridinventory = process(this.Invoicedata, this.state);
       
        this.loaderService.display(false);
      } else {
       
        this.loaderService.display(false);
        this.gridinventory = process(this.Invoicedata, this.state);
      }



     
     });


  }
 
  //  Final upload and view Challan and invoices  Start


   

  detectFiles($event) {

        // from old function START
        //   this.file = $event.target.files[0];
        //   this.fileSected = true;
        // from old function  END
   
       console.log('fileone');
       


		// get file
		const file1 = $event.target.files[0];

		// create storage ref
		const storageRef = firebase.storage().ref('/INVOICEANDCHALLAN/' + this.selectedInvoiceNumber);
		// console.log("FILENAME", file1.name);
		// Upload file
		const task = storageRef.put(file1);


		// Upload progress bar
		task.on('state_changed',
			(snapshot: any) => {
        console.log('fileTwo');
			},
			(error) => {
		
			},
			() => {
				storageRef.getDownloadURL().then((downloadURL) => {
					this.downloadURL = downloadURL;
					console.log("This is download URL", downloadURL);
          console.log('filethree');
				
				},
					(error) => {
						console.error('upload rejected', error);
					
					});
			}
		);
	}

  
  newUploadChallan() {
		if (this.downloadURL == null) {
			alert("Please add a document first!")
		
			return;
		}
		var obj = {
			id:this.selectedInvoiceNumber,
			filePath: this.downloadURL
		};
		console.log("upload data", obj)



    // return
		// this.http.post(environment.apiUrl + 'maintenance/uploadChallansAndInvoices',obj).subscribe((data) => {

    //   console.log('129',data);
      
       
    //   $(".filedoc").val("");

    //   $('#UpdateChallanFile').modal('hide');

    //   this.FinalInvoiceNumberCheck = false;

    // }, error => {
       
    // });
	}

  













  //  Final upload and view Challan and invoices  End    $('#partItemModal').modal('hide');



  InvoicePartsdetails(data){

    // console.log('365',data['InvoiceNumber'],data['billType']);
    


    $('#partItemModal').modal('show');


    this.getAllDataBYInvoceNumberBillType(data)



  }
  getAllDataBYInvoceNumberBillType(data) {

     var invoiceId = data['InvoiceNumber'];

     var billId = data['billType'];

     this.TotalQuantity =  data['totalStock'] 
     this.TotalAmount =   data['TotalCost']
     this.invoiceNumber  =     data['InvoiceNumber']

      this.partsIdArray = data['selectedIds']


      console.log('425',this.partsArray);

    this.http.get(environment.apiUrl + 'maintenance/getAllDataBYInvoceNumberBillType?prjId='+this.prjId+'&invoiceId='+invoiceId+'&billId='+billId+'&partsIdArray='+this.partsIdArray).subscribe((data) => {
      this.InvoiceWiseData = data ;

      console.log('this.Invoicedata',this.InvoiceWiseData);


     
     });



    
  }






  onDateRangeChangedPartReport(dateRange){

    if (dateRange.beginDate.day > 0) {
      this.defaultStartDate = dateRange.beginDate.year + "-" + dateRange.beginDate.month + "-" + dateRange.beginDate.day
      this.defaultEndDate = dateRange.endDate.year + "-" + dateRange.endDate.month + "-" + dateRange.endDate.day
       this.DateWisePartReort()
       this.getInvoicedata(this.defaultStartDate,this.defaultEndDate)
      // this.getTopPerformer()
    } else if (dateRange.beginDate.day == 0) {
      this.defaultStartDate = this.defaultStartDate
      this.defaultEndDate = this.defaultEndDate
      this.DateWisePartReort()
      this.getInvoicedata(this.defaultStartDate,this.defaultEndDate)
     
    }

  }



  DateWisePartReort(){

        
          


    let fromDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
    let toDate = moment(this.defaultEndDate).format('YYYY-MM-DD');


    this.http.get(environment.apiUrl + 'maintenance/DateWisePartReort?prjId=' + this.prjId+'&fromDt=' +
    fromDate +
    '&toDt=' +
    toDate).subscribe( (data) => {
      
     this.downloadExcelFile(data)
 
    })


  }





}



// WEBPACK FOOTER //
// ./src/app/maintenance/part/InvoiceAndChallan/invoiceAndChallan.component.ts